import { headers, baseUrl } from '../common/credentials.js';

export const port = "1200";

export const port1 = "1200";
export const port2 = "3501";

export const LoginUserToServer = () => {
    let url = baseUrl + "/api/v2/user_modules/validate_user/";
    return ([headers, url]);
}

export const JWTLoginToServer = (magicToken) => {
    const url = baseUrl + port + "/api/v2/user_modules/jwt_login/";

    const headers = {
        headers: {
            Authorization: `Bearer ${magicToken}`,
        },
    };

    const data = {};

    return [data, headers, url];
};

export const SendOtp = () => {
    let url = baseUrl + port + "/api/v2/user_modules/send-otp/";
    return ([headers, url]);
}

export const ValidateOtp = () => {
    let url = baseUrl + port + "/api/v2/user_modules/verify-otp/";
    return ([headers, url]);
}

export const CheckMFAStatus = () => {
    let url = baseUrl + port + "/api/v2/user_modules/mfa-status/";
    return ([headers, url]);
};

export const SetupMFA = () => {
    let url = baseUrl + port + "/api/v2/user_modules/setup-mfa/";
    return ([headers, url]);
};

export const FileUploadToServer = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/file_upload/";
    return ([headers, url]);
}
export const FileUploadToServernew = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/file_upload_new/";
    return ([headers, url]);
}

export const SheetDataUpload = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/sheet_upload/";
    return ([headers, url]);
}

export const UploadEditSheetData = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/edit_sheet_data/";
    return ([headers, url]);
}

export const SheetData = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/sheet_data/";
    return ([headers, url]);
}

export const Fetchexecutequery = () => {
    let url = baseUrl + port + "/api/v2/user_modules/getexecutequery/";
    return ([headers, url]);
}


export const SheetDatanew = () => {
    let url = baseUrl + port + "/api/v2/user_modules/sheet_data_new/";
    return ([headers, url]);
}

export const SheetNames = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/sheet_names/";
    return ([headers, url]);
}

export const TargetSheet = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/uploadtargetdata/";
    return ([headers, url]);
}

export const GetAllTarget = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/getalltenants/";
    return ([headers, url]);
}

export const GetTarget = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/gettenants/";
    return ([headers, url]);
}

export const CreateJob = () => {
    let url = baseUrl + port + "/api/v2/user_modules/createjob/";
    return ([headers, url]);
}

export const CreateUser = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/create/Users/";
    return ([headers, url]);
}

export const GetAllUsers = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/get_all/Users/";
    return ([headers, url]);
}

export const GetUser = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/getuser/";
    return ([headers, url]);
}

export const UpdateUsers = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/updateuser/";
    return ([headers, url]);
}

export const GetIdentifierlist = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/getidentifierlist/";
    return ([headers, url]);
}

export const getotp = () => {
    let url = baseUrl + port + "/api/v2/user_modules/generate_otp/";
    return ([headers, url]);
}

export const validate_otp = () => {
    let url = baseUrl + port + "/api/v2/user_modules/validate_otp/";
    return ([headers, url]);
}

export const save_password = () => {
    let url = baseUrl + port + "/api/v2/user_modules/save_password/";
    return ([headers, url]);
}

export const getidentifierlist = () => {
    let url = baseUrl + port + "/api/v2/user_modules/fetch_identifier_list/";
    return ([headers, url]);
}

export const SheetData1 = () => {
    let url = baseUrl + port + "/api/v2/user_modules/fetch_filter_sheet_data/";
    return ([headers, url]);
}